import { AbstractControl } from '@angular/forms';

// if error is null, remove the error if exists, using the code to identify the error;
export function setError(control: AbstractControl, error: any, code: string) {
    if (error) {
        control.setErrors({...control.errors, ...error});
    } else {
        if (control.errors) {
            if (control.getError(code)) {
                delete control.errors[code];
            }
            if (Object.keys(control.errors).length === 0) {
                control.setErrors(null);
            }
        }
    }
}
